import QueryChartCheckinTime from 'graphql/queries/management/QueryChartCheckinTime'
import QueryChartBookTime from 'graphql/queries/management/QueryChartBookTime'
import QueryChartEmployeeBookingsWeek from 'graphql/queries/management/QueryChartEmployeeBookingsWeek'
import QueryChartBookingsCreatedByWeekday from 'graphql/queries/management/QueryChartBookingsCreatedByWeekday'
import QueryChartBookingsScheduledByWeekday from 'graphql/queries/management/QueryChartBookingsScheduledByWeekday'
import QueryChartBookingsPresent from 'graphql/queries/management/QueryChartBookingsPresent'
import QueryChartTotalBookingsWeek from 'graphql/queries/management/QueryChartTotalBookingsWeek'
import QueryChartBookingsPresentWeek from 'graphql/queries/management/QueryChartBookingsPresentWeek'
import QueryChartBookingsPresentDay from 'graphql/queries/management/QueryChartBookingsPresentDay'
import QueryChartCheckinTimeGrow from 'graphql/queries/management/QueryChartCheckinTimeGrow'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchCharts = {

	fetch: ( name, query, variables, callbackStart = null, callbackSuccess = null, callbackError = null ) => {
		const queryName = name.replaceAll( '_', '-' )
		
		GraphqlGroupedBuilder.addQuery( queryName, query, {
			variables,
			resultPath: [ name ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	},
	
	fetchCheckinTime: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_checkin_time', QueryChartCheckinTime, variables, callbackStart, callbackSuccess, callbackError );
	},

	fetchCheckinTimeGrow: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_checkin_time_grow', QueryChartCheckinTimeGrow, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchBookTime: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_book_time', QueryChartBookTime, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchEmployeeBookingsWeek: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_employee_bookings_week', QueryChartEmployeeBookingsWeek, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchBookingsCreatedByWeekday: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_bookings_created_by_weekday', QueryChartBookingsCreatedByWeekday, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchBookingsScheduledByWeekday: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_bookings_scheduled_by_weekday', QueryChartBookingsScheduledByWeekday, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchBookingsPresent: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_bookings_present', QueryChartBookingsPresent, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchBookingsPresentWeek: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_bookings_present_week', QueryChartBookingsPresentWeek, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchBookingsPresentDay: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_bookings_present_day', QueryChartBookingsPresentDay, variables, callbackStart, callbackSuccess, callbackError );
	},
	
	fetchTotalBookingsWeek: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) => {
		FetchCharts.fetch( 'chart_total_bookings_week', QueryChartTotalBookingsWeek, variables, callbackStart, callbackSuccess, callbackError );
	},
}

export default FetchCharts
